import apiService from './api.service';

export interface CompanySettings {
  dataRetentionDays: number;
  maxRetentionDays: number;
  planName: string;
}

export interface DataStatistics {
  logs: number;
  traces: number;
  spans: number;
  rumSessions: number;
  rumEvents: number;
  rumPageViews: number;
  rumWebVitals: number;
  rumNetworkRequests: number;
  recordings: number;
  recordingEvents: number;
  metricDataPoints: number;
  infrastructureMetrics: number;
  uptimeChecks: number;
  errorOccurrences: number;
  mobileSessions: number;
  mobileCrashes: number;
  mobileAnr: number;
  totalRecords: number;
  storageEstimateGB: number;
}

export interface RetentionLimits {
  maxRetentionDays: number;
  currentRetentionDays: number;
  planName: string;
  minRetentionDays: number;
}

const companyApi = {
  /**
   * Get company settings
   */
  getSettings: async (): Promise<{ success: boolean; data: CompanySettings }> => {
    return apiService.get('/v1/company/settings');
  },

  /**
   * Update company settings
   */
  updateSettings: async (dataRetentionDays: number): Promise<{ success: boolean; data: CompanySettings; message: string }> => {
    return apiService.put('/v1/company/settings', { dataRetentionDays });
  },

  /**
   * Get data statistics
   */
  getDataStatistics: async (): Promise<{ success: boolean; data: DataStatistics }> => {
    return apiService.get('/v1/company/data-statistics');
  },

  /**
   * Get retention limits
   */
  getRetentionLimits: async (): Promise<{ success: boolean; data: RetentionLimits }> => {
    return apiService.get('/v1/company/retention-limits');
  },
};

export default companyApi;
